import { useMutation } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { ApiError, InferFetchData, throwOnError } from 'api/helpers';

function retryTaskAutomation(apiClient: ApiClient, taskId: number) {
  return apiClient.PUT('/op/v2/tasks/{id}/retry-automation', {
    params: { path: { id: taskId } },
  });
}

export default function useRetryTaskAutomationMutation() {
  const apiClient = useApiClient();

  return useMutation<InferFetchData<typeof retryTaskAutomation>, ApiError, number>({
    mutationKey: ['RetryTaskAutomation'],
    mutationFn: (taskId: number) => throwOnError(retryTaskAutomation(apiClient, taskId)),
  });
}
